export default "__VITE_ASSET__BGQDwp35__"